import React from 'react';
import logo from './logo.svg';
import './App.css';
import ScannerComp from "./Components/scannerComp";
import {PageLayout} from "./Components/pageLayout";

function App() {
  return (
    <div>
        <PageLayout/>
    </div>
  );
}

export default App;

// import React, { FC } from 'react';
// import { Button } from 'antd';
// import './App.css';
//
// const App: FC = () => (
//     <div className="App">
//         <Button type="primary">Button</Button>
//     </div>
// );
//
// export default App;
